import type { FilterOption } from "@gss/types/measurementStat";
import type { Selected } from "../types";
import type { TreeNode } from "./filters.types";

export const OPTION_ALL = "*";
export const SELECTION_CRITERIA_FILTER_VALUE = "selectionCriteria";
export const VERSION_FILTER_VALUE = "version";
export const PROFESSIONAL_CATEGORY_FILTER_VALUE = "professionalCategory";
export const TYPE_OF_VISIT_FILTER_VALUE = "typeOfVisit";
export const SVF_FILTER_VALUE = "svf";
export const DIAGNOSIS_FILTER_VALUE = "cancerDiagnosis";
export const SEX_FILTER_VALUE = "sex";

export function updateSelectedList(
    list: Selected[],
    option: Selected | FilterOption | TreeNode,
    include: boolean,
): Selected[] {
    if (include) {
        list.push(makeSelected(option));
    } else {
        const key = getValue(option);
        list.splice(
            list.findIndex((s) => s.key === key),
            1,
        );
    }
    return [...list];
}

export function makeSelected(
    option: Selected | FilterOption | TreeNode,
): Selected {
    const value = getValue(option);
    const name = option.name;
    return {
        key: value,
        name,
        options: [{ value, name }],
    };
}

export function combineSelected(selected: Selected[]): {
    key: string;
    name: string;
    options: { value: string; name: string }[];
} {
    return {
        key: selected
            .map((s) => s.key)
            .toSorted()
            .join(","),
        name: combineOptionNames(selected.map((s) => s.name).toSorted()),
        options: selected.map((s) => ({ value: s.key, name: s.name })),
    };
}

export function combineOptionNames(names: string[]): string {
    return names.join(" / ");
}

export function combineFilterNames(names: string[]): string {
    return names.join(" - ");
}

export function isAllOption(value: string): boolean {
    return value === OPTION_ALL;
}

function getValue(option: Selected | FilterOption | TreeNode): string {
    if (isSelected(option)) {
        return option.key;
    }
    if (isFilterOption(option)) {
        return option.value;
    }
    return option.data?.value ?? "";
}

export function isSelected(
    option: Selected | FilterOption | TreeNode,
): option is Selected {
    return "key" in option;
}

function isFilterOption(
    option: Selected | FilterOption | TreeNode,
): option is FilterOption {
    return "value" in option;
}

export function toFilterParam(
    filterValue: string,
    optionValue: string,
): string {
    return `${filterValue}:${optionValue}`;
}
